// Push notifications bootstrap for Capacitor (iOS/Android).
// No-op on web: functions return immediately if not running natively.
import { api } from "@/lib/api";

let initialized = false;
let currentToken = null;

export async function initPushNotifications(navigate) {
    if (initialized) return;
    let Capacitor, PushNotifications;
    try {
        Capacitor = (await import("@capacitor/core")).Capacitor;
        PushNotifications = (await import("@capacitor/push-notifications")).PushNotifications;
    } catch {
        return; // capacitor not available (web build)
    }
    if (!Capacitor.isNativePlatform()) return;

    initialized = true;

    try {
        let perm = await PushNotifications.checkPermissions();
        if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
            perm = await PushNotifications.requestPermissions();
        }
        if (perm.receive !== "granted") return;

        await PushNotifications.register();

        PushNotifications.addListener("registration", async (token) => {
            currentToken = token.value;
            try {
                await api.post("/devices/register", {
                    token: token.value,
                    platform: Capacitor.getPlatform(),
                });
            } catch (e) {
                if (process.env.NODE_ENV !== "production") {
                    console.warn("device register failed", e);
                }
            }
        });

        PushNotifications.addListener("registrationError", (err) => {
            if (process.env.NODE_ENV !== "production") {
                console.warn("push registration error:", err);
            }
        });

        // App in foreground: rely on in-app UI (badges refresh via polling)
        PushNotifications.addListener("pushNotificationReceived", () => {});

        // App in background: user tapped notification → deep-link
        PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
            const d = action?.notification?.data || {};
            let target = "/";
            if (d.type === "message") target = "/messaggi";
            else if (d.type === "news") target = "/news";
            else if (d.type === "communication") target = "/comunicazioni";
            else if (d.type === "convocation" && d.match_id) target = `/partite/${d.match_id}`;
            else if (d.type === "match_update" && d.match_id) target = `/partite/${d.match_id}`;
            if (navigate) navigate(target);
            else window.location.href = target;
        });
    } catch (e) {
        if (process.env.NODE_ENV !== "production") {
            console.warn("initPushNotifications failed:", e);
        }
    }
}

export async function unregisterDevice() {
    if (!currentToken) return;
    try {
        await api.delete(`/devices/register?token=${encodeURIComponent(currentToken)}`);
    } catch {}
    currentToken = null;
}
